/*
    - to deal with I might deploy to "module" or "beta" or ultimately "/"
    - some of the hard coded links (mostly the ones in markdown) were not working when I deployed Vue to different directories.

*/
export default {
  data: function () {
    return {};
  },
  methods: {
    // prepends Vue's root subdirectory to a link:
    prependBaseToLink(link) {
      let base = this.$router.options.base; // "/module/" or "/base/" or "/""
      let url = base + link;
      url.replace("//", "/");
      return url;
    },

    // looks for relative links in markdown and prepends Vue's root subdirectory to the links:
    // eg) "[nevus](/oc-dz/details/nevus)" -> "[nevus](/base/oc-dz/details/nevus)"
    prependBaseToMarkdownLinks(txt) {
      let base = this.$router.options.base;
      if (!txt) return "";
      // console.log(base);
      // console.log("text1", txt);
      let replaceTo = "](" + base + "$1)";
      let regex = /\]\(\/(.*?)\)/g;
      //   console.log("regex: ", regex);
      //   console.log("replaceTo: ", replaceTo);

      // eg) "[nevus](/oc-dz/details/nevus)" -> "[nevus](/base/oc-dz/details/nevus)"
      let result = txt.replaceAll(regex, replaceTo);
      //   console.log("text2", result);

      return result;
    },
  },
};
